export default __webpack_public_path__ + "static/desktop-4e36a1432b80b6f1fa1957030d33998e.png";